<template>
  <div
    class="settings-row settings-row-xs"
    data-test="graphics-cycleTimeSettings"
  >
    <div class="settings-col-12 settings-col-xs">
      <div class="input-group">
        <validation-field as="input"
          v-model.number="_cycleTime"
          rules="required|numeric|min:1"
          type="number"
          step="1"
          name="cycleTime"
          min="1"
          max="100"
          :class="{ 'is-invalid': validationErrors['cycleTime'] }"
          :data-test="`graphics-cycleTimeSettings-${action}`"
          :data-entity="`graphics-${action}`"
        />
        <span class="input-group-addon">sec</span>
      </div>
      <label class="sidebar-input-sub-label">Cycle speed (1-100)</label>
    </div>
    <p
      v-if="validationErrors['cycleTime']"
      class="text-danger"
    >
      {{ validationErrors['cycleTime'] }}
    </p>
  </div>
</template>

<script>
export default {
  emits: ['update:cycleTime'],
  name: 'CycleTimeSettingsComponent',
  props: {
    cycleTime: {
      required: true,
      type: Number,
      default: 5000,
    },
    action: {
      type: String,
      default: 'updateCycleSpeed',
    },
  },

  computed: {
    _cycleTime: {
      get() {
        return this.cycleTime / 1000;
      },
      set(v) {
        this.$emit('update:cycleTime', v * 1000);
      },
    },
  },
};
</script>
